import { type FC } from "react";
import Box from "@mui/material/Box";
import type { Stream, StreamContent } from "@/partner/entities/streams";
import { usePlatformFeature } from "@/partner/entities/platforms";
import { PlatformFeatureType } from "@/types/graphql/partner.generated";
import type { StreamTab } from "../model";
import { StreamTabsMenu } from "./StreamTabsMenu";
import { StreamEditTab } from "./StreamEditTab";
import { StreamBroadcastTab } from "./StreamBroadcastTab";
import { StreamRestreamsTab } from "./StreamRestreamsTab";
import { StreamStudioTab } from "./StreamStudioTab";
import { StreamMonitoringTab } from "./StreamMonitoringTab";
import { StreamPollsTab } from "./StreamPollsTab";
import { StreamSignalAlert } from "./StreamSignalAlert";

interface StreamFormProps {
  content: StreamContent;
  stream: Stream;
  tab: StreamTab;
  onClose: () => void;
}

// Шелл референсного StreamForm.js: табы + свитч контента; fixed-хедер со
// своими экшенами рендерит каждая вкладка сама (StreamDialogHeader), mt
// компенсирует его высоту. ?tab=polls без фичефлага открывает edit.
export const StreamForm: FC<StreamFormProps> = ({
  content,
  stream,
  tab,
  onClose,
}) => {
  const pollsEnabled = usePlatformFeature(PlatformFeatureType.PlayerPollsType);
  const activeTab: StreamTab = tab === "polls" && !pollsEnabled ? "edit" : tab;

  return (
    <>
      <Box sx={{ mt: { xs: "56px", sm: "64px" } }}>
        <StreamSignalAlert stream={stream} />
        <StreamTabsMenu tab={activeTab} />
      </Box>
      <Box
        sx={{
          p: 1,
          overflow: "auto",
          minHeight: 600,
          maxHeight: "calc(100vh - 64px)",
        }}
      >
        {activeTab === "edit" && (
          <StreamEditTab content={content} stream={stream} onClose={onClose} />
        )}
        {activeTab === "broadcast" && (
          <StreamBroadcastTab
            content={content}
            stream={stream}
            onClose={onClose}
          />
        )}
        {activeTab === "restream" && (
          <StreamRestreamsTab
            content={content}
            stream={stream}
            onClose={onClose}
          />
        )}
        {activeTab === "studio" && (
          <StreamStudioTab
            content={content}
            stream={stream}
            onClose={onClose}
          />
        )}
        {activeTab === "monitoring" && (
          <StreamMonitoringTab
            content={content}
            stream={stream}
            onClose={onClose}
          />
        )}
        {activeTab === "polls" && (
          <StreamPollsTab content={content} stream={stream} onClose={onClose} />
        )}
      </Box>
    </>
  );
};
